import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Dialog from '../../components/Dialog';
import { Typography, Button } from '../../components/Wrappers/Wrappers';
import { useStyles } from './otpSuccessDialog.styles';
import TickCircleOutline from '../images/icons/tickCircleOutline.svg?react';

function OTPSuccessDialog ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  showSecondaryButton,
  showPrimaryButton,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
      PaperProps={{
        classes: {
          root: classes.dialogContainer,
        },
      }}
    >
      <Grid className={classes.content}>
        <TickCircleOutline aria-hidden="true" />
        <Grid className={classes.textbox}>
          <Typography variant={'h5'} weight={'medium'} className={classes.successTitle}>
            {title}
          </Typography>
          <Typography variant={'body'} weight={'medium'} className={classes.successTitle}>
            {message}
          </Typography>
        </Grid>
        {showSecondaryButton && (
          <Button
            variant="outlined"
            className={classes.okButton}
            onClick={onClose}
          >
            {cancelLabel}
          </Button>
        )}
        {showPrimaryButton && (
          <Button
            variant="contained"
            className={classes.okButton}
            color={'white'}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        )}
      </Grid>
    </Dialog>
  );
}

OTPSuccessDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  showSecondaryButton: PropTypes.bool,
  showPrimaryButton: PropTypes.bool,
};

OTPSuccessDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onConfirm: () => {},
  title: "You're all set!",
  message: "Thanks for confirming it's you",
  confirmLabel: 'Ok',
  cancelLabel: 'CANCEL',
  showSecondaryButton: true,
  showPrimaryButton: true,
};

export default OTPSuccessDialog;
